// extracted by mini-css-extract-plugin
export default {"navbar__hamburger-icon":"Hamburger_navbar__hamburger-icon__miHfZ","open":"Hamburger_open__gnm9Y","navbar__hamburger":"Hamburger_navbar__hamburger__ce465"};